export function noop(): void {
  // no operation
}

export default noop;
